module.exports = __webpack_public_path__ + "static/img/sm_20.b5241f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_20.png
// module id = yRP/
// module chunks = 0